// Import model
import { SearchHighlights } from '../models/SearchHighlights';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { Match } from '../models/Match';

// Import dependency serializers (for complex types)
import { MatchSerializer } from './MatchSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SearchHighlights - handles JSON serialization and deserialization with type validation
 */
export class SearchHighlightsSerializer {
  /**
   * Deserializes a JSON string into a SearchHighlights instance
   */
  static deserialize(json: string): SearchHighlights {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SearchHighlights instance
   */
  static fromObject(obj: any): SearchHighlights {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SearchHighlights');
    }


    const instance: SearchHighlights = {
      path: obj['path'] as string | undefined,
      texts: obj['texts'] ? (obj['texts'] as any[]).map((item: any) =>
        MatchSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SearchHighlights instances
   */
  static deserializeArray(json: string): SearchHighlights[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SearchHighlights instance to a JSON string
   */
  static serialize(instance: SearchHighlights): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SearchHighlights instance to a plain object
   */
  static toObject(instance: SearchHighlights): any {
    return {
      'path': instance.path,
      'texts': instance.texts?.map((item: any) =>
        MatchSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of SearchHighlights instances to a JSON string
   */
  static serializeArray(instances: SearchHighlights[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
